module.exports = __webpack_public_path__ + "static/img/surface4.ef599e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface4.png
// module id = jdVs
// module chunks = 2